"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSliderLabel = void 0;
var _SliderLabel = require("./SliderLabel");
// TODO: in v9, move styled() from SliderLabel.jsx to here
var StyledSliderLabel = _SliderLabel.SliderLabel;
exports.StyledSliderLabel = StyledSliderLabel;